import script from "./ViewTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTable.vue?vue&type=script&setup=true&lang=js"

import "./ViewTable.vue?vue&type=style&index=0&id=736ca5ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-736ca5ba"]])

export default __exports__